import * as React from "react";
import s from "./Empty.module.scss";
//@ts-ignore
import EmptyImage from "./assets/nodata.svg";
// "../../../../nodata.svg";
import { Typography } from "@progress/kendo-react-common";
import classNames from "classnames";

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  text?: string;
}

export const Empty = ({ text, ...rest }: IProps) => {
  return (
    <div className={classNames(s.container, "empty-container")} {...rest}>
      <img src={EmptyImage} alt={"empty"} />
      <Typography.p style={{ marginTop: 2 }} fontSize={"medium"}>
        {text || "No data"}
      </Typography.p>
    </div>
  );
};

export default Empty;
